import styles from './Logo.module.css'

export interface LogoProps {
  name?: string
  logoUrl?: string | null
  endAdornment?: React.ReactNode
}

export default function Logo({ name, logoUrl, endAdornment }: LogoProps) {
  if (logoUrl) {
    return (
      <div className={styles.logo}>
        <span className={styles.nameRow}>
          <img src={logoUrl} alt={name ?? 'Challenge'} className={styles.logoImage} />
          {endAdornment}
        </span>
      </div>
    )
  }

  const nameParts = name?.split(/\s+/) ?? ['RELENTLESS']
  const first = nameParts[0]?.toUpperCase() ?? 'RELENTLESS'
  const rest = nameParts.slice(1).join(' ').toUpperCase()

  return (
    <div className={styles.logo}>
      <span className={styles.nameRow}>
        <span className={styles.name}>
          <span className={styles.blue}>{first}</span>
          {rest ? ` ${rest}` : ''}
        </span>
        {endAdornment}
      </span>
      <span className={styles.tagline}>A TEAM CHALLENGE</span>
    </div>
  )
}
